import { render, staticRenderFns } from "./departed.vue?vue&type=template&id=21becefa&"
import script from "./departed.vue?vue&type=script&lang=js&"
export * from "./departed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports